import React, { Suspense } from 'react';

export default (Component) => (props) =>
    (
        <Suspense fallback={<div />}>
            <Component {...props} />
        </Suspense>
    );
